import Seo from "@/components/Seo";
import { PageHero, CTABand, Reveal } from "@/components/ui-bits";
import { useSettings } from "@/hooks/useContent";
import { WORLD_MAP_IMAGE } from "@/lib/site";

const FALLBACK_MARKETS = [
  { name: "Middle East", description: "A focus region for long-term sourcing relationships with importers and distributors." },
  { name: "Africa", description: "Serving regional distributors and food businesses sourcing Indian food products." },
  { name: "Europe", description: "Supporting importers with product specifications, packaging and export coordination." },
  { name: "Asia", description: "Developing sourcing relationships with food businesses across Asian markets." },
  { name: "North America", description: "Engaging with importers and private-label buyers for Indian food products." },
  { name: "Other International Markets", description: "Open to enquiries from international B2B buyers worldwide." },
];

export default function Markets() {
  const { data: settings } = useSettings();
  const markets = (settings?.markets || []).length ? settings.markets : FALLBACK_MARKETS;

  return (
    <>
      <Seo
        title="Global Markets — Serving International B2B Buyers | Orvella Overseas"
        description="Orvella Overseas is focused on serving international B2B buyers and developing long-term sourcing relationships across global markets — Middle East, Africa, Europe, Asia and North America."
        path="/markets"
        image={WORLD_MAP_IMAGE}
      />

      <PageHero
        eyebrow="Markets We Serve"
        title="From India to Global Markets"
        sub="Orvella Overseas is focused on serving international B2B buyers and developing long-term sourcing relationships across global markets."
      />

      <section className="section-pad">
        <div className="container-x">
          <Reveal>
            <div className="overflow-hidden rounded-xl border border-line bg-white">
              <img src={WORLD_MAP_IMAGE} alt="World map highlighting Orvella Overseas target markets across the Middle East, Africa, Europe, Asia and North America" loading="lazy" className="h-auto w-full object-cover" />
            </div>
          </Reveal>
          <p className="mt-4 text-xs italic text-mist">
            This list represents our target markets — markets we are focused on serving. Current export destinations are confirmed by our export team per enquiry.
          </p>
          <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {markets.map((m, i) => (
              <Reveal key={m.name} delay={i * 0.04}>
                <div className="card card-hover h-full p-6" data-testid={`market-card-${m.name.toLowerCase().replace(/\s+/g, "-")}`}>
                  <h2 className="font-serif text-lg font-semibold text-navy">{m.name}</h2>
                  <p className="mt-2 text-sm leading-relaxed text-mist">{m.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand title="Sourcing from India for your market?" sub="Tell us your destination and requirement — our export team will confirm what we can support and respond with a quotation." />
    </>
  );
}
